// extracted by mini-css-extract-plugin
export default {"frameGradient":"Login_Normal_Forms_frameGradient__NUWzk","loginForms":"Login_Normal_Forms_loginForms__Wh93p","orLine":"Login_Normal_Forms_orLine__8h2gu"};